export interface Settings {
  baseUrl: string
  greenUpBaseUrl: string
}

export async function getSettings(): Promise<Settings> {
  const response = await fetch("/settings.json")

  return await response.json() as Settings
}
